import React from 'react';
import { Box, Container } from '@mui/material';
import { motion } from 'framer-motion';

const services = [
  { num: '01', title: 'Web Development', desc: 'Custom, responsive websites that showcase your business and connect with local customers.' },
  { num: '02', title: 'Mobile Apps', desc: 'User-friendly mobile applications that help small businesses provide better service and engagement.' },
  { num: '03', title: 'Cloud Solutions', desc: 'Affordable cloud systems that streamline operations and save you time for what matters most.' },
  { num: '04', title: 'Digital Marketing', desc: 'Local-focused marketing strategies that bring qualified customers to your small business.' },
  { num: '05', title: 'UI/UX Design', desc: 'Intuitive, attractive designs that reflect your brand personality and improve customer experience.' },
  { num: '06', title: 'Custom Software', desc: 'Tailored software for specific business challenges — from appointment systems to inventory management.' },
];

const ServicesSection = () => (
  <Box id="services" component="section" sx={{ borderBottom: '1px solid #1E3040' }}>
    <Container maxWidth="lg" sx={{ py: { xs: 8, md: 12 } }}>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true, margin: '-80px' }}
      >
        <Box sx={{
          fontSize: '10px', letterSpacing: '4px', textTransform: 'uppercase',
          color: '#FF914D', fontFamily: "'Barlow', sans-serif", mb: 2,
          display: 'flex', alignItems: 'center', gap: 1.5,
          '&::before': { content: '""', display: 'block', width: '24px', height: '1px', background: '#FF914D' },
        }}>
          Our Expertise
        </Box>
        <Box component="h2" sx={{
          fontFamily: "'Anton', sans-serif",
          fontSize: { xs: '48px', md: '60px' },
          textTransform: 'uppercase', lineHeight: 0.92,
          color: '#F0EEE8', m: 0, mb: 2.5,
        }}>
          What We<br />Deliver
        </Box>
        <Box component="p" sx={{
          fontFamily: "'Source Serif 4', Georgia, serif",
          fontStyle: 'italic', fontWeight: 300,
          fontSize: '16px', color: '#7A9AB0', lineHeight: 1.7,
          maxWidth: '520px', m: 0,
        }}>
          Affordable digital solutions built for local businesses — from first website to full cloud infrastructure.
        </Box>
      </motion.div>

      <Box sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
        gap: '1px',
        background: '#1E3040',
        mt: 8,
      }}>
        {services.map((s, i) => (
          <motion.div
            key={s.num}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: i * 0.07 }}
            viewport={{ once: true, margin: '-40px' }}
          >
            <Box sx={{
              background: '#162333', p: { xs: 4, md: 5 },
              transition: 'background 0.2s',
              height: '100%',
              '&:hover': { background: '#1a2d3f' },
              '&:hover .svc-num': { color: '#FF914D' },
            }}>
              <Box className="svc-num" sx={{
                fontFamily: "'Anton', sans-serif", fontSize: '40px',
                color: '#2A4560', lineHeight: 1, mb: 2.5,
                transition: 'color 0.2s',
              }}>
                {s.num}
              </Box>
              <Box component="h3" sx={{
                fontFamily: "'Anton', sans-serif", fontSize: '22px',
                textTransform: 'uppercase', color: '#F0EEE8',
                letterSpacing: '0.5px', m: 0, mb: 1.5,
              }}>
                {s.title}
              </Box>
              <Box component="p" sx={{
                fontFamily: "'Source Serif 4', Georgia, serif",
                fontStyle: 'italic', fontWeight: 300,
                fontSize: '14px', color: '#7A9AB0', lineHeight: 1.7, m: 0,
              }}>
                {s.desc}
              </Box>
            </Box>
          </motion.div>
        ))}
      </Box>
    </Container>
  </Box>
);

export default ServicesSection;
